import { Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import HeaderBar from '../../Layout/HeaderBar';
import FooterBar from '../../Layout/FooterBar';
import TableList from './Table';
import GroupsDrawer from './Drawer/GroupsDrawer';
import { DBGroupShape } from '../../modules/groups/types';
import AddGroup from './AddGroup';
import { Badge } from 'components/ui/badge';

interface IHomeViewProps {
  groups: DBGroupShape[];
  isLoading: boolean;
  hasError: boolean;
}

function GroupView({ groups, isLoading, hasError }: IHomeViewProps) {
  const { t } = useTranslation();
  return (
    <Layout>
      <HeaderBar />
      <Layout.Content className="px-4 py-6 md:px-6 md:py-8">
        <div className="mx-auto max-w-7xl space-y-6">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div>
              <div className="flex items-center gap-3">
                <h1 className="m-0 text-2xl font-semibold tracking-tight text-foreground">
                  {t('header.groups')}
                </h1>
                {!isLoading && !hasError && <Badge variant="secondary">{groups.length}</Badge>}
              </div>
              <p className="mb-0 mt-2 text-sm text-muted-foreground">
                {t('Overblik over dine afdelinger, opgaver og hovedlagre.')}
              </p>
            </div>
            <AddGroup />
          </div>
          <TableList data={groups} isLoading={isLoading} hasError={hasError} />
        </div>
        <GroupsDrawer />
      </Layout.Content>
      <FooterBar />
    </Layout>
  );
}

export default GroupView;
